'use client';

import { createContext, useContext, useState, useEffect, useCallback, ReactNode } from 'react';
import { Organization } from '@/lib/apistratorService';

const STORAGE_KEY = 'apistrator-default-org';

interface OrgContextValue {
  selectedOrg: Organization | null;
  setSelectedOrg: (org: Organization) => void;
  clearSelectedOrg: () => void;
}

const OrgContext = createContext<OrgContextValue>({
  selectedOrg: null,
  setSelectedOrg: () => {},
  clearSelectedOrg: () => {},
});

export const useOrg = () => useContext(OrgContext);

export function OrgProvider({ children }: { children: ReactNode }) {
  const [selectedOrg, setSelectedOrgState] = useState<Organization | null>(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) setSelectedOrgState(JSON.parse(stored));
    } catch {}
  }, []);

  const setSelectedOrg = useCallback((org: Organization) => {
    setSelectedOrgState(org);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(org)); } catch {}
  }, []);

  const clearSelectedOrg = useCallback(() => {
    setSelectedOrgState(null);
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  }, []);

  return (
    <OrgContext.Provider value={{ selectedOrg, setSelectedOrg, clearSelectedOrg }}>
      {children}
    </OrgContext.Provider>
  );
}
